import React, { useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { Close } from '@mui/icons-material'

const Riesgos: React.FC<{
  riesgos: string
}> = ({ riesgos }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [openRiesgos, setOpenRiesgos] = useState<boolean>(false)

  const handleClose = () => {
    setOpenRiesgos(false)
  }
  if (!riesgos) return
  return (
    <>
      <Button
        variant="outlined"
        color="error"
        onClick={() => setOpenRiesgos(true)}
        sx={{
          borderWidth: 2,
          borderStyle: 'dashed',
          borderColor: 'red',
          animation: 'blinkBorder 1s infinite',
          transition: 'none',
          boxSizing: 'border-box',
          '@keyframes blinkBorder': {
            '0%, 100%': {
              borderColor: 'red'
            },
            '50%': {
              borderColor: 'transparent'
            }
          },
          '&:hover': {
            borderWidth: 2,
            borderStyle: 'dashed',
            borderColor: 'red',
            backgroundColor: 'transparent'
          }
        }}
      >
        RIESGOS DETECTADOS ⚠️
      </Button>
      <Dialog
        open={openRiesgos}
        onClose={handleClose}
        PaperProps={{
          sx: {
            display: 'flex',
            width: isMobile ? '90%' : { xs: '90vw', sm: 550 },
            maxWidth: isMobile ? '90%' : '90vw',
            marginLeft: '-20px'
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          RIESGOS DETECTADOS ⚠️
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography>{riesgos}</Typography>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default Riesgos
